export default __webpack_public_path__ + "static/media/google-upload-3-en.e4313bca.jpeg";